import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CollectionApiClient } from '../../../../core';
import { UtilityManagementCollections } from '../../../..';
import { IDeviceTopicResponse, ISetDeviceTopicSubscriptionRequest } from '../dtos';
import { IDeviceTopicsApiClient } from './i-device-topics-api.client';

@Injectable({
  providedIn: 'root'
})
export class DeviceTopicsApiClient implements IDeviceTopicsApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(UtilityManagementCollections.Notifications, http);
  }

  get(deviceIdentifier: string): Observable<IDeviceTopicResponse[]> {
    return this.collectionApiClient.get({
      collectionName: UtilityManagementCollections.deviceTopics(deviceIdentifier)
    });
  }

  setSubscription(
    deviceIdentifier: string,
    topicId: string,
    request: ISetDeviceTopicSubscriptionRequest
  ): Observable<void> {
    return this.collectionApiClient.put({
      collectionName: UtilityManagementCollections.deviceTopics(deviceIdentifier),
      id: topicId,
      body: request
    });
  }
}
